import { motion } from "framer-motion";
import {
  Fingerprint,
  GraduationCap,
  BadgeCheck,
  FileCheck,
  UserCog,
} from "lucide-react";

const pillars = [
  {
    icon: Fingerprint,
    title: "5-Tier Vetting",
    desc: "Criminal background, ID verification, service aptitude, drug screening, and reference checks — before anyone wears the badge.",
  },
  {
    icon: GraduationCap,
    title: "Event Protocol Academy",
    desc: "Every crew member completes mandatory training in de-escalation, radio etiquette, and emergency egress.",
  },
  {
    icon: BadgeCheck,
    title: "Zero No-Show Guarantee",
    desc: "A 15% standby reserve team stays on-call for every gig. Your posts are filled — period.",
  },
  {
    icon: FileCheck,
    title: "Fully Insured & Compliant",
    desc: "We absorb workers comp, payroll tax, superannuation, and liability. No contractor risk lands on your desk.",
  },
  {
    icon: UserCog,
    title: "Dedicated Onsite Captain",
    desc: "One point of contact who briefs, deploys, and manages your team from doors to teardown.",
  },
];

export default function DifferentiatorsSection() {
  return (
    <section id="why-us" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative order-2 lg:order-1"
          >
            <img
              src="https://images.unsplash.com/photo-1653930351140-d8dca047455e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxldmVudCUyMHN0YWZmJTIwdGVhbSUyMGhvc3BpdGFsaXR5fGVufDB8fHx8MTc4ODkyNTYyM3ww&ixlib=rb-4.1.0&q=85"
              alt="Uniformed Sora crew member"
              className="rounded-md w-full h-[480px] object-cover border border-white/10"
              data-testid="why-us-image"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="order-1 lg:order-2"
          >
            <p className="text-xs uppercase tracking-[0.2em] font-mono-tactical font-semibold text-sky-400">
              The Sora Standard
            </p>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight text-white">
              5 Pillars Every Client Gets
            </h2>

            <div className="mt-8 space-y-6">
              {pillars.map((p, i) => (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, y: 14 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.45, delay: i * 0.07 }}
                  data-testid={`pillar-${i + 1}`}
                  className="flex gap-4"
                >
                  <span className="shrink-0 w-11 h-11 rounded-sm bg-sky-500/10 border border-sky-500/25 flex items-center justify-center">
                    <p.icon className="w-5 h-5 text-sky-500" />
                  </span>
                  <div>
                    <h3 className="font-display text-lg font-bold text-white">
                      {p.title}
                    </h3>
                    <p className="mt-1 text-sm text-slate-400 leading-relaxed">
                      {p.desc}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
